import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { TranslationService } from '@df/ui/translation/translation.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { IfNotTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-not-trade-store.directive';
interface IProductViewDeliveryCoutdownComponentData extends NICmsContentComponent.IData {}
@ICmsComponent<ProductViewDeliveryCoutdownComponent>({
    id: 'delivery-coutdown',
    name: 'Delivery Coutdown',
    tags: ['delivery', 'coutdown'],
    fields: []
})
@Component({
    selector: 'product-view-delivery-coutdown',
    templateUrl: './product-view-delivery-coutdown.html',
    standalone: true,
    imports: [IfNotTradeStoreDirective],
    changeDetection: ChangeDetectionStrategy.Default
})
export class ProductViewDeliveryCoutdownComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component: IProductViewDeliveryCoutdownComponentData;
    private staticHour = 15;
    private staticMinutes = 60;
    date = new Date();
    day = this.date.getDay();
    coutdown = this.coutdownHours();
    private intervalId?: number;
    @NgInject(TranslationService)
    private translationService: TranslationService;
    override ngOnInit() {
        super.ngOnInit();
        this.cleanup();
        this.intervalId = this.timeoutService.setInterval(() => {
            this.coutdown = this.coutdownHours();
            this.detectChanges();
        }, 1000);
    }
    override ngOnDestroy() {
        this.cleanup();
    }
    private cleanup() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    }
    changeHour(hour: number) {
        const numbers = [0, 1];
        return numbers.includes(hour) ? 'hour' : 'hours';
    }
    coutdownHours() {
        const _currentDate = new Date();
        const _hoursToEnd = (_currentDate.getHours() - this.staticHour) * -1;
        let hours = `${(_hoursToEnd - (_currentDate.getMinutes() == 60 ? 24 : 23) + '').padStart(2, '0')}`;
        const hoursToEnd = this.changeHour(_hoursToEnd);
        const minutesToEnd = `${(_currentDate.getMinutes() == 0 ? 0 : _currentDate.getMinutes() - this.staticMinutes) * -1}`.padStart(
            2,
            '0'
        );
        let day = this.translationService.transform('TOMORROW');
        if (_currentDate.getHours() < this.staticHour && this.day <= 5 && this.day > 0) {
            hours = `${_hoursToEnd - (_currentDate.getMinutes() == 0 ? 0 : 1)}`.padStart(2, '0');
            day = this.translationService.transform('TODAY');
        } else if (_currentDate.getHours() >= this.staticHour && this.day == 5) {
            hours = `${_hoursToEnd - (_currentDate.getMinutes() == 0 ? 72 : 71) * -1}`.padStart(2, '0');
            day = this.translationService.transform('on MONDAY');
        } else if (_currentDate.getHours() >= this.staticHour && this.day <= 5 && this.day > 0) {
            hours = `${_hoursToEnd - (_currentDate.getMinutes() == 0 ? 24 : 23) * -1}`.padStart(2, '0');
            day = this.translationService.transform('TOMORROW');
        } else if (this.day == 6) {
            hours = `${_hoursToEnd - (_currentDate.getMinutes() == 0 ? 48 : 47) * -1}`.padStart(2, '0');
            day = this.translationService.transform('on MONDAY');
        } else if (this.day == 0) {
            hours = `${_hoursToEnd - (_currentDate.getMinutes() == 0 ? 24 : 23) * -1}`.padStart(2, '0');
            day = this.translationService.transform('on MONDAY');
        } else if (_currentDate.getHours() === this.staticHour && this.day < 5 && this.day > 0) {
            return this.translationService.transform(`Order in the next 24 % 00 minutes for dispatch TOMORROW`, hoursToEnd);
        }
        return this.translationService.transform('Order in the next % % % minutes for dispatch %', hours, hoursToEnd, minutesToEnd, day);
    }
}
